import * as React from "react";
import { Link, graphql, useStaticQuery } from "gatsby";
import * as styles from './footer.module.css'
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";

const commonImageProps = {
  layout: "constrained",
  placeholder: "blurred",
  formats: ["auto", "webp"],
  outputPixelDensities: [0.5, 0.75, 1, 2],
}

export const quickLinks = [
    { text: "Home", url: "/" },
    { text: "Courses", url: "/courses" },
    { text: "Learnet Institute", url: "/learnet-institute" },
    { text: "CSR-Sponsored Initiatives", url: "/csr" },
    { text: "About Us", url: "/about-us" },
    { text: "Contact Us", url: "/contact-us" },
  ];
  
  const otherLinks = [
    { text: "Privacy Policy", url: "/privacy-policy" },
    { text: "Terms & Conditions", url: "/terms-of-use" },
    { text: "Careers", url: "/careers" },
    { text: "Blog" },
  ];
  

const Footer = ({wrapperClasses = 'bg-white pt-10 border-t container mx-auto'}) => {
    
  // const socialImages = categorizeImages(data.social.nodes)
  const socialLinks = [
    {link: 'https://www.facebook.com/LearnetSkills', image: <StaticImage
      src="../../images/common/social/facebook.png"
      alt="logo of Facebook - a social media"
      {...commonImageProps}
    />},
    {link: 'https://x.com/LearnetSkills', image: <StaticImage
      src="../../images/common/social/twitter.png"
      alt="logo of X - a social media"

      {...commonImageProps}
    />},
    {link: 'https://www.instagram.com/learnetskills/', image: <StaticImage
      src="../../images/common/social/insta.png"
      alt="logo of Instagram - a social media"

      {...commonImageProps}
    />},
    {link: 'https://www.linkedin.com/company/learnet-skills-limited', image: <StaticImage
      src="../../images/common/social/linkedin.png"
      alt="logo of Linkdin "

      {...commonImageProps}
    />},
    {link: 'https://www.youtube.com/@LearnetSkills', image: <StaticImage
      src="../../images/common/social/youtube.png"
      alt="logo of Youtube "

      {...commonImageProps}
    />},
  ]

  return (
    <div className={wrapperClasses}>
      <div className="mx-auto flex flex-col md:flex-row justify-between gap-8">
        <div className="md:w-2/5 flex flex-col px-10 md:px-0 md:pl-4">
            <Link to={'/'}>
              <StaticImage
                src="../../images/common/logo/LearnetLogo.png"
                alt="Learnet Logo"
                className={styles.footerLogo}
                layout="constrained"
                placeholder="none"
                formats={["auto", "webp"]}
                outputPixelDensities={[0.5, 0.75, 1, 2]}
              />
            </Link>
        </div>
        <div className="md:w-1/5 flex flex-col px-10 md:px-0">
          <h5 className={`text-lg font-semibold mb-4 ${styles.footerHeading}`}>Quick Links</h5>
          {quickLinks.map((link, index) => (
            <Link key={index} to={link.url} className={`text-[#626262] hover:text-[#626262] no-underline ${styles.footerText}`}>
                {link.text}
            </Link>
          ))}
        </div>
        <div className="md:w-1/5 flex flex-col px-10 md:px-0">
          <h5 className={`text-lg font-semibold mb-4 ${styles.footerHeading}`}>Other Links</h5>
          {otherLinks.map((link, index) => (
            <Link key={index} to={link.url} className={`text-[#333333] hover:text-[#333333] no-underline ${styles.footerText}`}>
                {link.text}
            </Link>
          ))}
        </div>
        <div className="md:w-1/5 px-10 md:px-0">
          <h5 className={`text-lg font-semibold mb-4 ${styles.footerHeading}`}>Follow us on</h5>
          <div className="flex space-x-4 mb-4">
            {socialLinks.map((val, index)=>(
              <a 
                key={index} 
                href={val.link || ''} 
                className={`text-[#333333] hover:text-[#333333] no-underline cursor-pointer ${styles.footerText}`}
                target="_blank"
                rel="noreferrer"
              >
                {val.image}
              </a>
            ))}
          </div>
          <div>
            <h5 className={`text-lg font-semibold mb-4 ${styles.footerHeading}`}>Get Support</h5>
            <div className="flex flex-col">
              <a className={`flex gap-2  items-center text-[#333333] hover:text-[#333333] no-underline ${styles.footerText}`} href="tel:+911204844444 ">
                <StaticImage
                  src="../../images/common/footer/telephone.png"
                  alt="Telephone icon"
                  className={styles.mailIcon}
                  {...commonImageProps}
                />
                <div>0120-484-4444 </div>
              </a>
              <a className={`flex gap-2  items-center text-[#333333] hover:text-[#333333] no-underline ${styles.footerText}`} href="mailto:info@learnetskills.com">
                <StaticImage
                  src="../../images/common/footer/mail.png"
                  alt="mail icon"
                  className={styles.mailIcon}
                  {...commonImageProps}
                />
                <div style={{ wordBreak: 'break-all' }}>info@learnetskills.com</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center text-sm text-gray-600 py-4 border-t border-[#78FCB4] mt-4">
        © Learnet Skills Limited
      </div>
    </div>
  );
};

export default Footer;
